"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignDraftToJSON = exports.CampaignDraftFromJSONTyped = exports.CampaignDraftFromJSON = exports.instanceOfCampaignDraft = void 0;
var runtime_1 = require("../runtime");
var CampaignAdProduct_1 = require("./CampaignAdProduct");
var CampaignChannel_1 = require("./CampaignChannel");
var DeliveryGoalGroup_1 = require("./DeliveryGoalGroup");
var OptimizationPrefs_1 = require("./OptimizationPrefs");
/**
 * Check if a given object implements the CampaignDraft interface.
 */
function instanceOfCampaignDraft(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCampaignDraft = instanceOfCampaignDraft;
function CampaignDraftFromJSON(json) {
    return CampaignDraftFromJSONTyped(json, false);
}
exports.CampaignDraftFromJSON = CampaignDraftFromJSON;
function CampaignDraftFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'draftHierarchyVersion': !(0, runtime_1.exists)(json, 'draft_hierarchy_version') ? undefined : json['draft_hierarchy_version'],
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'purchaseOrder': !(0, runtime_1.exists)(json, 'purchase_order') ? undefined : json['purchase_order'],
        'objective': !(0, runtime_1.exists)(json, 'objective') ? undefined : (0, OptimizationPrefs_1.OptimizationPrefsFromJSON)(json['objective']),
        'channel': !(0, runtime_1.exists)(json, 'channel') ? undefined : (0, CampaignChannel_1.CampaignChannelFromJSON)(json['channel']),
        'adProduct': !(0, runtime_1.exists)(json, 'ad_product') ? undefined : (0, CampaignAdProduct_1.CampaignAdProductFromJSON)(json['ad_product']),
        'salesforceOpportunity': !(0, runtime_1.exists)(json, 'salesforce_opportunity') ? undefined : json['salesforce_opportunity'],
        'salesforceSalesOrder': !(0, runtime_1.exists)(json, 'salesforce_sales_order') ? undefined : json['salesforce_sales_order'],
        'deliveryGoalGroup': !(0, runtime_1.exists)(json, 'delivery_goal_group') ? undefined : (0, DeliveryGoalGroup_1.DeliveryGoalGroupFromJSON)(json['delivery_goal_group']),
    };
}
exports.CampaignDraftFromJSONTyped = CampaignDraftFromJSONTyped;
function CampaignDraftToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'draft_hierarchy_version': value.draftHierarchyVersion,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'name': value.name,
        'purchase_order': value.purchaseOrder,
        'objective': (0, OptimizationPrefs_1.OptimizationPrefsToJSON)(value.objective),
        'channel': (0, CampaignChannel_1.CampaignChannelToJSON)(value.channel),
        'ad_product': (0, CampaignAdProduct_1.CampaignAdProductToJSON)(value.adProduct),
        'salesforce_opportunity': value.salesforceOpportunity,
        'salesforce_sales_order': value.salesforceSalesOrder,
        'delivery_goal_group': (0, DeliveryGoalGroup_1.DeliveryGoalGroupToJSON)(value.deliveryGoalGroup),
    };
}
exports.CampaignDraftToJSON = CampaignDraftToJSON;
